export default __webpack_public_path__ + "static/media/adobe-illustrator-cc.136c43ee.svg";